module.exports = __webpack_public_path__ + "static/media/Novozymes-Bd.1a444d1d.woff";